import React from "react";
import { Reveal, SectionEyebrow } from "@/components/shared/Reveal";
import PulseBriefForm from "@/components/shared/PulseBriefForm";
import { PULSE_TESTIDS } from "@/lib/pulseConstants";

export default function LeadCaptureSection() {
    return (
        <section
            className="section-pad relative bg-gradient-to-b from-[#0A0B10] via-[#07070A] to-[#07070A]"
            data-testid={PULSE_TESTIDS.form.section}
            id="pulse-brief"
        >
            <div className="container-editorial">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
                    <div className="lg:col-span-5">
                        <SectionEyebrow index="07" label="Start A Project" />
                        <Reveal>
                            <h2 className="display-2 text-white text-balance">
                                Got a brand moment
                                <br />
                                coming up?
                            </h2>
                        </Reveal>
                        <Reveal delay={0.1}>
                            <p className="body-lg mt-5">
                                Share the shape of the brief. We will review it and come back with the <span className="text-white">right next step</span>.
                            </p>
                        </Reveal>

                        <Reveal delay={0.15}>
                            <div className="mt-10 space-y-4 border-l border-white/15 pl-6">
                                {[
                                    { k: "01", t: "You send the brief", d: "Tell us the brand, audience, objective, timing and budget." },
                                    { k: "02", t: "We shape the opportunity", d: "We identify the strategic angle, creative territory and right format." },
                                    { k: "03", t: "We build it with you", d: "From concept and production to creators, content and amplification." },
                                ].map((step) => (
                                    <div key={step.k} className="flex gap-4">
                                        <span className="font-mono text-xs text-[#FF2A2A] tracking-[0.24em] pt-1">{step.k}</span>
                                        <div>
                                            <div className="text-white font-medium">{step.t}</div>
                                            <div className="text-sm text-white/60">{step.d}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </Reveal>
                    </div>

                    <div className="lg:col-span-7">
                        <Reveal delay={0.1}>
                            <PulseBriefForm sourcePage="home" />
                        </Reveal>
                    </div>
                </div>
            </div>
        </section>
    );
}
